import React, { type ReactElement } from 'react';
import classNames from 'classnames';
import { useRouter } from 'nextjs-toploader/app';
import Button from '@/common/components/button/button.component';
import CustomImage from '@/common/components/custom-image';
import Text from '@/common/components/text/text.component';

interface CollectionItem {
  title: string;
  description: string;
  imageCover: string;
}

interface CollectionCardProps {
  id: number;
  className?: string;
  collectionItem: CollectionItem;
  isPrimary?: boolean;
  handleSelect?: () => void;
  onClick: () => void;
}

export default function CollectionCard({
  id,
  className,
  collectionItem,
  isPrimary,
  handleSelect,
  onClick,
}: CollectionCardProps): ReactElement {
  const router = useRouter();

  return (
    <div
      className={classNames(
        'relative !h-[160px] w-full grow overflow-hidden lg:!h-[120px] cursor-pointer',
        { ' lg:!h-[172px]': isPrimary },
        { ' lg:!h-[120px] lg:!max-w-[264px]  ': !isPrimary },

        className
      )}
      onClick={onClick}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black-default/80 to-transparent z-10 rounded-md" />
      <div
        onClick={handleSelect}
        className={classNames(
          'relative !h-[160px] w-full transition-transform duration-300 lg:!h-[120px]',
          { ' lg:!h-[172px]': isPrimary },
          { ' lg:!h-[120px]': !isPrimary }
        )}
      >
        <CustomImage
          alt={collectionItem.title}
          src={collectionItem.imageCover}
          className="rounded-md object-cover"
          fill
          sizes="(max-width: 1023px) 80vw, 24vw"
        />
        <div className="absolute inset-0 z-10 rounded-md bg-gradient-to-t from-black/60 to-black/10"></div>
        <div
          className={classNames(
            'absolute bottom-0 right-0 z-20 flex w-full flex-col items-start justify-start gap-y-1 px-3',
            {
              'pb-3': isPrimary,
              'pb-5': !isPrimary,
            }
          )}
        >
          <div className="flex flex-col items-start justify-start gap-y-1">
            <Text className="text-[16px] font-semibold text-white">
              {collectionItem.title}
            </Text>

            <Text className="text-xs font-medium text-white">
              {collectionItem.description}
            </Text>
          </div>

          {isPrimary && (
            <Button
              className={classNames(
                'z-50 mt-1 h-8 px-3 text-xs font-normal !shadow-none cursor-pointer'
              )}
              onClick={() => {
                router.push(
                  `/collection/${id}/${collectionItem.title.replace(/\s+/g, '-')}}`
                );
              }}
              type="black"
            >
              مشاهده محصولات
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
